export default {"src":"/_next/static/media/google-icon.64655368.svg","height":36,"width":37,"blurWidth":0,"blurHeight":0};